export default {
  title: 'Brand nou',
  tabs: {
    general: 'General',
    branding: 'Branding',
    scripts: 'Scripturi',
    tracking: 'Urmărire',
    domain: 'Domeniu',
  },
  fields: {
    name: {
      label: 'Nume',
      placeholder: 'Nume brand',
    },
    slug: {
      label: 'Subdomeniu',
      placeholder: 'Subdomeniu brand',
      hint: 'Litere mici, cifre și cratime. Împreună cu domeniul magazinului formează adresa magazinului.',
      preview: 'Adresa magazinului: {{url}}',
      availability: {
        taken: 'Un alt brand folosește deja acest subdomeniu pe acest domeniu de magazin.',
        reserved: 'Acest subdomeniu este rezervat. Alegeți altul.',
        invalid_label:
          'Pe acest domeniu de magazin, subdomeniul poate conține doar litere mici, cifre și cratime, trebuie să înceapă și să se termine cu o literă sau o cifră și poate avea cel mult 63 de caractere.',
        taken_elsewhere: 'Un brand de pe alt domeniu de magazin folosește deja acest subdomeniu. Alegeți altul.',
        format: 'Folosiți doar litere, cifre, cratime și underscore.',
        unavailable: 'Acest subdomeniu nu este disponibil. Alegeți altul.',
      },
    },
    shop_domain_id: {
      label: 'Domeniu magazin',
      placeholder: 'Selectați un domeniu de magazin',
      move_warning: {
        title: 'Aceasta schimbă adresa magazinului pe care o folosesc clienții',
        description:
          'După salvare, magazinul va fi la {{url}}. Codurile QR, fluturașii și linkurile deja tipărite sau distribuite cu vechea adresă nu vor mai funcționa.',
      },
    },
    lieferando_url: {
      label: 'URL Lieferando',
      placeholder: 'URL-ul restaurantului pe Lieferando',
    },
    primary_color: {
      label: 'Culoare principală',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Imagine',
    },
    companies: {
      label: 'Restaurante',
    },
    noscripts: {
      description: 'Inserează cod imediat după deschiderea body',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Token acces conversii Facebook',
    },
    google_analytics_id: {
      label: 'ID Google Analytics',
    },
    google_ads_conversion_label_id: {
      label: 'Etichetă conversie Google Ads',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Domeniu propriu pentru magazinul online',
    },
  },
  buttons: {
    save: 'Salvează',
    close: 'Închide',
    sync_from_lieferando: 'Sincronizează din Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Modificările au fost salvate cu succes!',
    failed_to_update_company_slug: 'Actualizarea slug-ului pentru {{name}} a eșuat',
    failed_to_sync_lieferando: 'Sincronizarea datelor din Lieferando a eșuat',
    successfully_synced_lieferando: 'Date sincronizate cu succes din Lieferando',
    failed_to_load_shop_domains: 'Nu s-au putut încărca domeniile magazinului.',
  },
};
